import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// ═══════════════════════════════════════════════════════════
// useWebhookStatus — LIVE B24 webhook event status (event.get),
// not the D1 cache. This is the source of truth the Settings panel
// and the out-of-sync banner should read from — the cache can lag
// or (if a sync attempt failed) go stale until the next reconcile.
// ═══════════════════════════════════════════════════════════

export interface WebhookSyncStatus {
  handlerUrl: string;
  required: string[];
  bound: string[];
  missing: string[];
  extra: string[];
  staleHandlers: Array<{ event: string; handler: string }>;
  inSync: boolean;
  checkedAt: number;
}

export function useWebhookStatus(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.webhookStatus,
    queryFn: () => api.get<WebhookSyncStatus>("/api/admin/webhooks/status"),
    staleTime: 30_000,
    enabled: options?.enabled ?? true,
  });
}
